import { ScaleLoader } from "react-spinners";

export function LoadingPage({ viewType }: { viewType: "list" | "grid" }) {
  const messageElement = (
    <div className="text-center">
      <ScaleLoader color="#4B5563" radius={10} className="mx-auto mb-4" />
      <div className="text-gray-500 text-sm mb-4">
        Working to find the best results...
      </div>
    </div>
  );

  if (viewType === "grid") {
    return (
      <div>
        {messageElement}
        <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 mx-2 lg:mx-0">
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
          <div className="animate-pulse bg-gray-200 rounded-lg h-40 w-full"></div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {messageElement}
      <div className="grid grid-cols-1 gap-x-6 gap-y-10 mx-2 lg:mx-0">
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
        <div className="animate-pulse bg-gray-200 rounded-lg h-7 w-full"></div>
      </div>
    </div>
  );
}
